<template>
  <v-card
    :height="height"
    :width="width"
    :style="{ background: background }"
    :flat="flat == undefined || flat == false ? false : true"
    style="text-align: center; direction: ltr"
    class="d-flex flex-column align-items-center justify-content-center"
  >
    <v-card-text
      class="pa-0 d-contents d-flex align-items-center justify-content-center"
      style="width: 40%"
    >
      <v-progress-circular
        class=""
        :rotate="270"
        :size="100"
        :width="5"
        :value="percentage"
        color="teal"
        ref="circle"
        @click.native="handleCircleClick"
      >
        <v-img
          class=""
          style="border-radius: 100%"
          :src="imageCover ?? 'media/musicDefault.webp'"
          height="88"
          width="88"
        >
        </v-img>
        <v-btn
          width="20"
          height="20"
          class="position-absolute"
          color="green"
          fab
          small
          elevation="0"
          v-if="editCover"
          @click="$emit('image', id)"
        >
          <v-icon color="white">mdi-plus</v-icon>
        </v-btn>
      </v-progress-circular>
    </v-card-text>

    <v-card-text
      class="pa-0 d-flex align-items-center flex-column justify-content-center ma-0"
    >
      <v-btn
        color="teal"
        small
        outlined
        icon
        class="ma-2"
        @click.native="mute()"
        :disabled="!loaded"
      >
        <v-icon v-if="!isMuted">{{ volumeHighIcon }}</v-icon>
        <v-icon v-else>{{ volumeMuteIcon }}</v-icon>
      </v-btn>
      <p :style="{ color: color }" class="ma-0">
        {{ persian(currentTime) }} / {{ persian(duration) }}
      </p>
    </v-card-text>

    <v-card-text style="width: 60%" class="pa-0">
      <v-card-subtitle
        style="width: auto; height: 50px"
        class="pa-0 ma-0 text-center"
        v-if="editName"
      >
        <v-text-field
          outlined
          height="15px"
          append-icon="mdi-close"
          prepend-inner-icon="mdi-check"
          width="150px"
          dense
          :disabled="loading"
          v-model="editNameText"
          :loading="loading"
          @click:prepend-inner="updateTitleName()"
          @click:append="editName = false"
        ></v-text-field>
      </v-card-subtitle>
      <v-card-subtitle v-else class="text-break pa-2">
        <v-icon
          v-if="link"
          @click="
            editName = true;
            editNameText = title;
          "
          size="15"
          >mdi-pencil</v-icon
        >
        <p
          :style="{
            color: color,
            width: '100%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }"
          class="ma-0"
        >
          {{ title }}
        </p>
      </v-card-subtitle>

      <v-card-text
        class="pa-0 mb-4 d-flex align-items-center justify-content-center"
      >
        <v-btn
          dark
          small
          height="45px"
          width="70px"
          style="
            z-index: 1;
            margin-right: -10px;
            border-top-left-radius: 15px;
            border-bottom-left-radius: 15px;
          "
          elevation="0"
          @click.native="stop()"
          :disabled="!loaded"
        >
          <v-icon>{{ stopIcon }}</v-icon>
        </v-btn>
        <v-btn
          @click.native="playing ? pause() : play()"
          :disabled="!loaded"
          :loading="loading"
          fab
          style="z-index: 2; border: 2px solid white !important"
          :style="{ animation: 'colorPulse 1s ease-in-out infinite' }"
          color="teal"
          class="border shadows"
          large
          elevation="0"
          v-if="loaded"
        >
          <v-icon color="white" v-if="!playing || paused">{{
            playIcon
          }}</v-icon>
          <v-icon color="white" v-else>{{ pauseIcon }}</v-icon>
        </v-btn>
        <v-btn
          v-else
          :loading="loading"
          fab
          style="z-index: 2; border: 2px solid white !important"
          :style="{ animation: 'colorPulse 1s ease-in-out infinite' }"
          color="teal"
          class="border shadows"
          large
          elevation="0"
          @click.native="loaded ? download() : reload()"
        >
          <v-icon>{{ refreshIcon }}</v-icon>
        </v-btn>
        <v-btn
          elevation="0"
          dark
          small
          height="45px"
          width="70px"
          style="
            z-index: 1;
            margin-left: -10px;
            border-top-right-radius: 15px;
            border-bottom-right-radius: 15px;
          "
          @click.native="loaded ? download() : reload()"
          v-if="loaded && downloadable"
        >
          <v-icon color="white">{{ downloadIcon }}</v-icon>
        </v-btn>
      </v-card-text>

      <v-slider
        v-if="audioSound"
        v-model="playerVolume"
        :prepend-icon="volumeHighIcon"
        style="padding: 0 10rem"
        max="1"
        step="0.01"
        min="0"
      ></v-slider>
      <audio
        id="player"
        ref="player"
        v-on:ended="ended"
        v-on:canplay="canPlay"
        :src="file"
      ></audio>
    </v-card-text>
  </v-card>
</template>
<script>
import { ir } from "../../../../../../check_domain_ir";
import { Bus } from "../../../../../../main";
import { parseBlob } from "music-metadata-browser";

const formatTime = (second) =>
  new Date(second * 1000).toISOString().substr(11, 8);

export default {
  name: "newPlayer",
  props: {
    flat: {
      type: Boolean,
      default: false,
    },
    file: {
      type: String,
      default: null,
    },
    autoPlay: {
      type: Boolean,
      default: false,
    },
    ended: {
      type: Function,
      default: () => {},
    },
    canPlay: {
      type: Function,
      default: () => {},
    },
    color: {
      type: String,
      default: null,
    },
    downloadable: {
      type: Boolean,
      default: true,
    },
    playIcon: {
      type: String,
      default: "mdi-play",
    },
    pauseIcon: {
      type: String,
      default: "mdi-pause",
    },
    stopIcon: {
      type: String,
      default: "mdi-stop",
    },
    refreshIcon: {
      type: String,
      default: "mdi-refresh",
    },
    downloadIcon: {
      type: String,
      default: "mdi-download",
    },
    volumeHighIcon: {
      type: String,
      default: "mdi-volume-high",
    },
    volumeMuteIcon: {
      type: String,
      default: "mdi-volume-mute",
    },
    audioSound: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [Number, String],
      default: "200",
    },
    width: {
      type: [Number, String],
      default: "100%",
    },
    title: String,
    id: [String, Number],
    link: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: null,
    },
    background: {
      type: String,
      default: "white",
    },
    image: {
      type: String,
      default: null,
    },
    editCover: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    image: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.imageCover = val;
          this.loading = false;
        }
      },
    },
  },
  computed: {
    duration: function () {
      return this.audio ? formatTime(this.totalDuration) : "";
    },
  },
  data() {
    return {
      firstPlay: true,
      isMuted: false,
      loaded: false,
      playing: false,
      paused: false,
      percentage: 0,
      currentTime: "00:00:00",
      audio: undefined,
      totalDuration: 0,
      playerVolume: 1,
      editName: false,
      editNameText: "",
      url: process.env.VUE_APP_ROBOT,
      loading: false,
      imageCover: null,
      value: 1,
      loading: true,
    };
  },

  methods: {
    async extractCover(blob) {
      this.loading = true;

      try {
        if (blob.size === 0) throw new Error("Empty blob");

        const metadata = await parseBlob(blob);
        const picture = metadata.common.picture?.[0];
        
        if (picture) {
          const coverBlob = new Blob([picture.data], { type: picture.format });
          this.imageCover = URL.createObjectURL(coverBlob);
        } else {
          this.imageCover = null;
        }
      } catch (err) {
        console.warn("Could not extract cover, using default.", err);
        this.imageCover = null; 
      } finally {
        this.loading = false;
      }
    },

    async handleUrl() {
      if (!!this.image) {
        return;
      } else {
        this.loading = true;

        try {
          const response = await fetch(this.file);
          if (!response.ok) throw new Error(this.$t("download_failed"));

          const blob = await response.blob();
          await this.extractCover(blob);
        } catch (err) {
          console.error(err);
        } finally {
          this.loading = false;
        }
      }
    },

    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },

    handleCircleClick(e) {
      const circle = this.$refs.circle.$el;
      const rect = circle.getBoundingClientRect();

      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      const x = e.clientX - centerX;
      const y = e.clientY - centerY;

      const angle = Math.atan2(y, x) * (180 / Math.PI); // زاویه کلیک
      let fixedAngle = angle + 90; // چون rotate رو 270 گذاشتی

      if (fixedAngle < 0) fixedAngle += 360;
      if (fixedAngle > 360) fixedAngle -= 360;

      const newPercent = Math.round((fixedAngle / 360) * 100);
      this.percentage = newPercent;

      this.setPosition(newPercent); // تابعی که seek پخش موزیک رو تنظیم می‌کنه
    },

    setPosition() {
      this.audio.currentTime = parseInt(
        (this.audio.duration / 100) * this.percentage
      );
    },
    stop() {
      this.audio.pause();
      this.paused = true;
      this.playing = false;
      this.audio.currentTime = 0;
    },
    play() {
      if (this.playing) return;
      this.audio.play().then((_) => (this.playing = true));
      this.paused = false;
    },
    pause() {
      this.paused = !this.paused;
      this.playing = !this.playing;
      this.paused ? this.audio.pause() : this.audio.play();
    },
    async download() {
      this.audio.pause();

      const response = await fetch(this.file);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = this.title ?? this.$t("audio_file_default");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url); // {{ $t('memory_release') }}
    },
    mute() {
      this.isMuted = !this.isMuted;
      this.audio.muted = this.isMuted;
    },
    reload() {
      this.audio.load();
    },
    _handleLoaded: function () {
      if (this.audio.readyState >= 2) {
        if (this.audio.duration === Infinity) {
          // Fix duration for streamed audio source or blob based
          // https://stackoverflow.com/questions/38443084/how-can-i-add-predefined-length-to-audio-recorded-from-mediarecorder-in-chrome/39971175#39971175
          this.audio.currentTime = 1e101;
          this.audio.ontimeupdate = () => {
            this.audio.ontimeupdate = () => {};
            this.audio.currentTime = 0;
            this.totalDuration = parseInt(this.audio.duration);
            this.loaded = true;
          };
        } else {
          this.totalDuration = parseInt(this.audio.duration);
          this.loaded = true;
        }

        if (this.autoPlay) this.audio.play();
      } else {
        throw new Error("Failed to load sound file");
      }
    },
    _handlePlayingUI: function (e) {
      this.audio.volume = this.playerVolume;
      this.percentage = (this.audio.currentTime / this.audio.duration) * 100;
      this.currentTime = formatTime(this.audio.currentTime);
      this.playing = true;
    },
    _handlePlayPause: function (e) {
      if (e.type === "play" && this.firstPlay) {
        // in some situations, audio.currentTime is the end one on chrome
        this.audio.currentTime = 0;
        if (this.firstPlay) {
          this.firstPlay = false;
        }
      }
      if (
        e.type === "pause" &&
        this.paused === false &&
        this.playing === false
      ) {
        this.currentTime = "00:00:00";
      }
    },
    _handleEnded() {
      this.paused = this.playing = false;
    },
    init: function () {
      this.audio.addEventListener("timeupdate", this._handlePlayingUI);
      this.audio.addEventListener("loadeddata", this._handleLoaded);
      this.audio.addEventListener("pause", this._handlePlayPause);
      this.audio.addEventListener("play", this._handlePlayPause);
      this.audio.addEventListener("ended", this._handleEnded);
    },

    updateTitleName() {
      if (this.link) {
        this.loading = true;
        const local_url = ir(this.url);
        this.$api
          .put(`${local_url}/files/update/${this.id}`, {
            title: this.editNameText,
          })
          .then((data) => {
            this.$toast.success(this.$t("successfully_completed"));
            this.editNameText = "";
            this.editName = false;
            Bus.$emit("updateList", true);
          })
          .catch((err) => {
            this.$toast.error(this.$t("problem_occurred"));
          })
          .finally(() => (this.loading = false));
      } else {
        try {
          this.$emit("click", { id: this.id, title: this.editNameText });
          this.$toast.success(this.$t("successfully_completed"));
          this.editNameText = "";
          this.editName = false;
        } catch {
          this.$toast.error(this.$t("problem_occurred"));
        } finally {
          this.loading = false;
        }
      }
    },
  },
  mounted() {
    this.audio = this.$refs.player;
    this.handleUrl();
    this.init();

    if (this.isIOS()) {
      this.reload();
    } else {
      console.log("android");
    }
  },
  beforeDestroy() {
    this.audio.removeEventListener("timeupdate", this._handlePlayingUI);
    this.audio.removeEventListener("loadeddata", this._handleLoaded);
    this.audio.removeEventListener("pause", this._handlePlayPause);
    this.audio.removeEventListener("play", this._handlePlayPause);
    this.audio.removeEventListener("ended", this._handleEnded);
  },
};
</script>

<style scoped>
.ltr-progress .v-progress-linear__bar {
  left: 0 !important;
  right: auto !important;
}
.no-shadow {
  box-shadow: none !important;
}

.no-hover .v-btn:hover {
  background-color: transparent !important;
  box-shadow: none !important;
}

.responsive-width {
  width: 100% !important;
  max-width: 600px;
  margin: auto;
}
.shadows {
  box-shadow: inset 0px 6px 12px rgba(0, 0, 0, 0.4),
    inset 0px -6px 12px rgba(80, 80, 80, 0.25) !important;
}
</style>

<style>
@keyframes colorPulse {
  0% {
    box-shadow: 0 0 10px #00fff2, 0 0 20px #00fff2, 0 0 30px #00fff2;
    background-color: #00fff2;
  }
  50% {
    box-shadow: 0 0 20px #ff00f2, 0 0 40px #ff00f2, 0 0 60px #ff00f2;
    background-color: #ff00f2;
  }
  100% {
    box-shadow: 0 0 10px #00fff2, 0 0 20px #00fff2, 0 0 30px #00fff2;
    background-color: #00fff2;
  }
}
</style>
